module.exports = __webpack_public_path__ + "img/GDP-2-sp.10b62d46.jpg";